import { render, staticRenderFns } from "./GroupEditForm.vue?vue&type=template&id=13dc7535"
import script from "./GroupEditForm.vue?vue&type=script&lang=js"
export * from "./GroupEditForm.vue?vue&type=script&lang=js"
import style0 from "./GroupEditForm.vue?vue&type=style&index=0&id=13dc7535&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports